import Smartphones from 'Salaries/views/SalaryEditView/containers/Smartphones'
import Tablets from 'Salaries/views/SalaryEditView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const SalaryEditView = getCurrentDeviceView(Smartphones, Tablets)

export default SalaryEditView
